"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var KEYS = {
  8: 'onBackspace',
  9: 'onTab',
  13: 'onEnter',
  27: 'onEsc',
  32: 'onSpace',
  37: 'onLeft',
  38: 'onUp',
  39: 'onRight',
  40: 'onDown',
  188: 'onComma',
  16: 'onShift'
};

var Keyboard = function Keyboard(props) {
  var onKeyDown = function onKeyDown(event) {
    var onKeyDownExternal = props.onKeyDown;
    var key = event.keyCode ? event.keyCode : event.which;
    var callbackName = KEYS[key];
    /* eslint-disable react/destructuring-assignment */

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    if (callbackName && props[callbackName]) {
      props[callbackName].apply(props, [event].concat(rest));
    }
    /* eslint-enable react/destructuring-assignment */


    if (onKeyDownExternal) {
      onKeyDownExternal.apply(void 0, [event].concat(rest));
    }
  };

  (0, _react.useEffect)(function () {
    var target = props.target;

    if (target === 'document') {
      document.addEventListener('keydown', onKeyDown);
    }

    return function () {
      /* eslint-disable-next-line no-shadow */
      var target = props.target;

      if (target === 'document') {
        document.removeEventListener('keydown', onKeyDown);
      }
    };
  }, []);
  var children = props.children,
      target = props.target;
  return target === 'document' ? children : (0, _react.cloneElement)(_react.Children.only(children), {
    onKeyDown: onKeyDown
  });
};

var _default = Keyboard;
exports["default"] = _default;